export default function SectionTitle({ eyebrow, title, accent, description, light = false }) {
    return (
        <div className={`school-heading ${light ? "school-heading--light" : ""}`}>
            <span className="school-heading__eyebrow">{eyebrow}</span>
            <h2>
                {title} <em>{accent}</em>
            </h2>
            {description && <p>{description}</p>}
        </div>
    );
}